module.exports = __webpack_public_path__ + "media/dashboard/assets/images/brain-56f4844a858ae137571f96da3a6234e7.svg";